/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Maybe<T> = T | undefined | null;
export type InputMaybe<T> = T | undefined | null;

export type IDownloadProcedureInput = {
  /** @deprecated Use x-device-id header */
  deviceIdentifier?: string | null | undefined;
  email: string;
  procedureUid: string;
};

export type IIncreaseViewCountInput = {
  /** @deprecated Use x-device-id header */
  deviceIdentifier?: string | null | undefined;
  /** @deprecated No longer user */
  deviceIp?: string | null | undefined;
  /** @deprecated No longer used */
  deviceUserAgent?: string | null | undefined;
  procedureUid: string;
};

export type ILogUserSearchInput = {
  industrySlug?: string | null | undefined;
  search?: string | null | undefined;
  topicSlug?: string | null | undefined;
};

export enum IPaginationCursorType {
  Date = 'DATE',
  MultiSort = 'MULTI_SORT',
  Offset = 'OFFSET'
}

export type IPaginationInput = {
  cursor?: string | null | undefined;
  cursorType?: IPaginationCursorType | null | undefined;
  limit?: number | null | undefined;
};

export enum IProcedureRowChoiceColor {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export enum IProcedureRowType {
  Check = 'CHECK',
  Checklist = 'CHECKLIST',
  Condition = 'CONDITION',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  File = 'FILE',
  FileSignature = 'FILE_SIGNATURE',
  Heading = 'HEADING',
  Meter = 'METER',
  Number = 'NUMBER',
  NumberAmount = 'NUMBER_AMOUNT',
  Radio = 'RADIO',
  RadioStandardTest = 'RADIO_STANDARD_TEST',
  RadioYesnona = 'RADIO_YESNONA',
  Section = 'SECTION',
  Text = 'TEXT'
}

export enum IProcedureSectionType {
  Industry = 'INDUSTRY',
  Topic = 'TOPIC'
}

export type ISidebarQueryVariables = Exact<{ [key: string]: never; }>;


export type ISidebarQuery = { __typename: 'Query', industries: Array<{ __typename: 'Industry', slug: string, label: string }>, topics: Array<{ __typename: 'Topic', slug: string, label: string }> };

export type IProcedureListingQueryVariables = Exact<{
  industrySlug?: string | null | undefined;
  topicSlug?: string | null | undefined;
  searchQuery?: string | null | undefined;
  useProcedureList: boolean;
}>;


export type IProcedureListingQuery = { __typename: 'Query', industry: { __typename: 'Industry', slug: string, label: string } | undefined | null, topic: { __typename: 'Topic', slug: string, label: string } | undefined | null, proceduresSummary?: Array<{ __typename: 'ProceduresSummary', slug: string, label: string, totalCount: number | undefined | null, type: IProcedureSectionType, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> }>, procedures?: { __typename: 'PaginatedProcedures', hasMore: boolean, cursor: string, count: number | undefined | null, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> } };

export type IProcedureListingMoreQueryVariables = Exact<{
  industrySlug?: string | null | undefined;
  topicSlug?: string | null | undefined;
  searchQuery?: string | null | undefined;
  pagination: IPaginationInput;
}>;


export type IProcedureListingMoreQuery = { __typename: 'Query', procedures: { __typename: 'PaginatedProcedures', hasMore: boolean, cursor: string, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> } };

export type ILogUserSearchMutationMutationVariables = Exact<{
  input: ILogUserSearchInput;
}>;


export type ILogUserSearchMutationMutation = { __typename: 'Mutation', logUserSearch: { __typename: 'LogUserSearchResponse', success: boolean, errors: Array<{ __typename: 'FieldError', fieldPath: string, fieldValue: string, error: string }> | undefined | null } };

export type IProcedureListingFragmentFragment = { __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null };

export type IThumbnailFragmentFragment = { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null };

export type IProcedurePageQueryVariables = Exact<{
  uid: string;
}>;


export type IProcedurePageQuery = { __typename: 'Query', procedure: { __typename: 'Procedure', description: string | undefined | null, scoringEnabled: boolean, maxScore: number | undefined | null, introduction: string | undefined | null, uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, source: { __typename: 'ProcedureSource', name: string | undefined | null, url: string | undefined | null } | undefined | null, rows: Array<{ __typename: 'ProcedureRow', id: number, parentId: number | undefined | null, label: string, type: IProcedureRowType, required: boolean, description: string, maxScore: number | undefined | null, condition: string | undefined | null, choices: Array<{ __typename: 'ProcedureRowChoice', label: string, color: IProcedureRowChoiceColor | undefined | null, score: number | undefined | null }> | undefined | null, attachment:
        | { __typename: 'FileAttachment', id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string }
        | { __typename: 'ImageAttachment', resizableUrl: string, width: number | undefined | null, height: number | undefined | null, id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string }
        | { __typename: 'LinkAttachment', id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string }
       | undefined | null, attachments: Array<
        | { __typename: 'FileAttachment', id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string }
        | { __typename: 'ImageAttachment', resizableUrl: string, width: number | undefined | null, height: number | undefined | null, id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string }
        | { __typename: 'LinkAttachment', id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string }
      > | undefined | null }>, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null } | undefined | null };

export type ISimilarProceduresQueryVariables = Exact<{
  uid: string;
}>;


export type ISimilarProceduresQuery = { __typename: 'Query', similarProcedures: { __typename: 'PaginatedProcedures', cursor: string, hasMore: boolean, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> } };

export type IIncreaseViewCountMutationMutationVariables = Exact<{
  input: IIncreaseViewCountInput;
}>;


export type IIncreaseViewCountMutationMutation = { __typename: 'Mutation', increaseViewCount: { __typename: 'IncreaseViewCountResponse', success: boolean, newCount: number | undefined | null, errors: Array<{ __typename: 'FieldError', fieldPath: string, fieldValue: string, error: string }> | undefined | null } };

export type IDownloadProcedureMutationVariables = Exact<{
  input: IDownloadProcedureInput;
}>;


export type IDownloadProcedureMutation = { __typename: 'Mutation', downloadProcedure: { __typename: 'DownloadProcedureResponse', success: boolean, download: { __typename: 'Download', filename: string, url: string } | undefined | null, errors: Array<{ __typename: 'FieldError', fieldPath: string, fieldValue: string, error: string }> | undefined | null } };

export type IProcedurePdfPageQueryVariables = Exact<{
  uid: string;
}>;


export type IProcedurePdfPageQuery = { __typename: 'Query', procedure: { __typename: 'Procedure', uid: string, _pdfHTML: { __typename: 'PdfHTML', header: string, body: string, footer: string } | undefined | null } | undefined | null };

export type IIndexPageQueryVariables = Exact<{ [key: string]: never; }>;


export type IIndexPageQuery = { __typename: 'Query', proceduresSummary: Array<{ __typename: 'ProceduresSummary', slug: string, label: string, totalCount: number | undefined | null, type: IProcedureSectionType, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> }> };
